import script from "./ConfluenceDashboardGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceDashboardGroups.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceDashboardGroups.vue?vue&type=style&index=0&id=bb0dd59a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb0dd59a"]])

export default __exports__